import React from 'react';
import './Error.css';

interface ErrorBoundaryProps extends React.PropsWithChildren {
}

type ErrorBoundaryState = {
  hasError: true;
  message: string;
} | {
  hasError: false;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({hasError: true, message: error.message})
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <span className="leading">
            <img src={`${process.env.PUBLIC_URL}/assets/i0004.png`} alt="beavely" width={"120px"}/>
            大変申し訳ございません！
            <img src={`${process.env.PUBLIC_URL}/assets/i0019.png`} alt="beavety" width={"120px"}/>
          </span>
          <span className="message">
          {this.state.message}
          </span>
        </div>
      );
    }
    return this.props.children;
  }
}
